import { apiClient } from "@/lib/api/client";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { IndividualAdditionalDataWithAttachments } from "./type";

async function getAdditionalDataById(
  individualId: string,
  additionalDataId: string,
): Promise<IndividualAdditionalDataWithAttachments> {
  const url = `/v1/individuals/${individualId}/additional-data/${additionalDataId}`;

  const response =
    await apiClient.get<IndividualAdditionalDataWithAttachments>(url);

  return response.data;
}

export function useGetAdditionalDataById(
  individualId: string,
  additionalDataId: string | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    additionalDataId
      ? [`fetch-additional-data-${individualId}-${additionalDataId}`]
      : null,
    () => getAdditionalDataById(individualId, additionalDataId!),
    mergedOptions,
  );
}
